module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Volume-full-5bc3d89fb0fec144fce9b0b941874936.svg";